export default __webpack_public_path__ + "static/media/fontRoboto700_latin_ext.ed67ad54.woff2";